import React, { useState } from 'react';

import { Popover } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import styled from 'styled-components';
import { StyledGrid, StyledIconButton, StyledPaper, StyledTooltip, StyledTypography } from 'styles/common';

import { FEEDBACK_FORM_TYPE, MESH_LIST_TABS, TASK_TYPES_2 } from 'constants/ProjectConstants';
import { getColorFromKey } from 'constants/helper';
import { RequestIcon, ShareIcon } from 'constants/icons';
import { sendClickedOnCreateKRevent, sendCreatedNewFromTabsOfHomepageEvent } from 'constants/mixpanelHelper';

const CustomStyledIconButton = styled(StyledIconButton)`
  &.MuiIconButton-root.Mui-disabled {
    background-color: ${getColorFromKey('primary')};
  }
  &.MuiButtonBase-root {
    width: ${(props) => (props.size === 'big' ? '28px' : '24px')};
    height: ${(props) => (props.size === 'big' ? '28px' : '24px')};
  }
`;

const StyledAddIcon = styled(AddIcon)`
  width: ${(props) => (props.size === 'big' ? '20px' : '16px')};
  height: ${(props) => (props.size === 'big' ? '20px' : '16px')};
`;

export default function CreateTask({
  createHandler,
  createNewInProgress,
  size = 'small',
  type = TASK_TYPES_2.goal,
  employee,
}) {
  const getTooltipMessage = () => {
    if (type === TASK_TYPES_2.goal) {
      return 'Add Goal';
    }
    if (type === TASK_TYPES_2.task) {
      return 'Add Initiative';
    }
    if (type === MESH_LIST_TABS.feedback.taskType) {
      return 'Share Feedback';
    }
    return '';
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    sendCreatedNewFromTabsOfHomepageEvent({
      eventProperties: {
        type: type === TASK_TYPES_2.goal ? 'Goals' : 'Initiatives',
      },
    });
    if (type === TASK_TYPES_2.goal) {
      sendClickedOnCreateKRevent({
        eventProperties: {
          source: 'Mesh List',
        },
      });
    }
    if (type === MESH_LIST_TABS.feedback.taskType) {
      setAnchorEl(event.currentTarget);
    } else {
      createHandler({});
    }
  };

  const handleDropdownItemClick = (feedbackType) => {
    createHandler({ feedbackType });
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const [showTooltip, setShowTooltip] = useState(false);

  const DROPDOWN_LIST = [
    {
      id: 'share-feedback',
      title: 'Share Feedback',
      value: FEEDBACK_FORM_TYPE.PROVIDED,
      icon: <ShareIcon color="primary" />,
    },
    {
      id: 'request-feedback',
      title: 'Request Feedback',
      value: FEEDBACK_FORM_TYPE.REQUESTED,
      icon: <RequestIcon color="primary" />,
    },
  ];

  return (
    <>
      <Container className="onboardingStep3">
        <StyledTooltip
          disableHoverListener
          disableFocusListener={createNewInProgress}
          title={getTooltipMessage()}
          open={showTooltip}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <CustomStyledIconButton
            className={`create-${type === TASK_TYPES_2.goal ? 'goal' : 'task'}-${employee?.id}`}
            circular
            color={createNewInProgress ? 'white' : 'primary'}
            backgroundColor={createNewInProgress ? 'primary' : 'white'}
            borderColor="primary"
            size={size}
            leftGutter={2}
            padding="xLarge"
            onClick={(e) => {
              handleClick(e);
              setShowTooltip(false);
            }}
            disabled={createNewInProgress}
          >
            <StyledAddIcon size={size} />
          </CustomStyledIconButton>
        </StyledTooltip>
      </Container>
      <StyledPopover
        id="create-meshlist-dropdown"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <StyledPaper>
          {DROPDOWN_LIST.map((item) => (
            <RowContainer onClick={() => handleDropdownItemClick(item.value)}>
              <StyledGrid container justify="space-between" alignItems="center">
                <StyledGrid item xs={2}>
                  {item.icon}
                </StyledGrid>
                <StyledGrid item xs={10}>
                  <StyledTypography leftGutter={1} variant="body2">
                    {item.title}
                  </StyledTypography>
                </StyledGrid>
              </StyledGrid>
            </RowContainer>
          ))}
        </StyledPaper>
      </StyledPopover>
    </>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1.5rem;
  position: relative;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.palette.background.blue.light.v2};
  }
  transition: all 0.2s;
`;

const StyledPopover = styled(Popover)`
  .MuiPopover-paper {
    margin-top: 5px;
  }
`;
